import { type FC, type ReactNode, useMemo } from "react";

import { type SnapAccountsServer, snapSSOTokenStorage } from "@snapchat/sso-auth";

import { abExposureLoggingStore } from "../../../cof-feature-gates/models";
import { ACCOUNTS_SERVER, CLIENT_ID } from "../../../shared/constants";
import { SnapSSOAPIClientWithPreRedirect } from "../SSOAPIClientWithPreRedirect";
import { SSOService } from "../SSOService";

import { SnapSSOAuthContext } from "./SnapSSOAuthContext";

export const SnapSSOAuthProvider: FC<{ children?: ReactNode }> = ({ children }) => {
    const snapSSOAPIClient = useMemo(
        () =>
            new SnapSSOAPIClientWithPreRedirect(
                {
                    clientId: CLIENT_ID,
                    accountsServer: ACCOUNTS_SERVER as SnapAccountsServer,
                },
                () => {
                    abExposureLoggingStore.removeItem();
                },
            ),
        [],
    );
    const snapSSOService = useMemo(
        () =>
            new SSOService({
                ssoAPIClient: snapSSOAPIClient,
                ssoTokenStorage: snapSSOTokenStorage,
                historyPush: (path) => {
                    // // TODO potentially window.history.pushState
                    // console.log("PATH", path);
                    // navigate(path);

                    window.location.href = path;
                },
            }),
        [snapSSOAPIClient],
    );

    return <SnapSSOAuthContext.Provider value={snapSSOService}>{children}</SnapSSOAuthContext.Provider>;
};
